export const mxPicks = {
  computed: {
    teams() {
      return this.$store.getters.teams
    }
  },
  methods: {
    getResult(picks) {
      return picks.map(pick => {
        let teams = this.getTeams(pick)
        let stats = this.getStats(teams)
        let result = {teams, stats}      
        return ({pick, result})
      })  
    },
    getTeams(pick) {
      let t = []
      pick.teams.forEach(i => {
        t.push(this.teams[i])
      })
      return t.sort((a, b) => {
        return a.seed - b.seed
      });
    },
    getStats(teams) {
      let m = [0,1,2,4,8,16,32]
      let result = { left: 90, total: 0, teams: teams.length };
      teams.forEach((team) => {
        result.left -= (17 - team.seed);
        for (var i = 0; i <= m.indexOf(team.round); i++) {
          result.total += (team.seed * m[i]);
        }
      })
      result.total += result.left;
      return result
    },
  }
}